<template>
    <Poptip placement="bottom-end" popper-class="room-info" transfer>
        <Button size="small" type="info" style="margin-left: 15px">{{ $t('Button.moreInfo') }}</Button>
        <div slot="content">
            <div class="item-info">
                <span class="title">
                    <span
                        v-decode="p.roomTitle.length>15?(p.roomTitle.substring(0,13)+'...'):p.roomTitle"
                        class="titleLink"
                        :title="p.roomTitle"
                        @click="toDetail(p.roomId)"
                    ></span>
                    <span>（{{ p.roomType == 1 ? tt('liveRoomManagement.roomType.dedicatedLiveRoom')
                                        : (p.roomType == 5? $t('liveRoomManagement.roomType.slowLiveRoom')
                                        : (p.roomType == 4? $t('liveRoomManagement.roomType.linkLiveRoom'):tt('liveRoomManagement.roomType.publishLiveRoom'))) }}）</span>
                    <span
                        v-if="p.paidLive == 1"
                        class="title-tag"
                        style="background-color: #ff6666;margin-right: 5px"
                    >
                        <Icon type="md-lock" size="12" style="color: #ffffff;" />
                    </span>
                    <span
                        v-if="p.roomType == 2"
                        :class="p.publishStatus == 0 ? 'title-tag' : 'title-tag title-tag-act'"
                    >
                        <PrettyText :text="Const.liveRoom.publishStatus(p.publishStatus)" />
                    </span>
                    <ForbiddenSpan :forbidden="p.forbidden" :memo="p.memo"></ForbiddenSpan>
                    <span
                        v-show="p.status == 1"
                        style="
                        margin-left: 5px;
                        padding: 2px;
                        color: white;
                        background-color: #FF6666;
                        border-radius: 5px;
                        font-size: 12px;
                        text-align: center"
                    >{{ $t('liveRoomManagement.liveRoomList.List.pushingTag') }}</span>
                </span>
                <ul class="list">
                    <li>
                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.roomId') }}</span>
                        <span class="content">{{p.roomId}}</span>
                    </li>
                    <li v-if="selectType!=1">
                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.userName') }}</span>
                        <span class="content">{{p.userName}}</span>
                    </li>
                    <li>
                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.globalCategoryName') }}</span>
                        <span
                            class="content"
                        >{{ p.globalCategoryName == '' ? $t('Message.explainEmpty') : p.globalCategoryName }}</span>
                    </li>
                    <li>
                        <span class="title">{{ $t('liveRoomManagement.liveRoomList.List.thumbList.categoryName') }}</span>
                        <span class="content">{{ !p.categoryName ? $t('Message.explainEmpty') : p.categoryName }}</span>
                    </li>
                    <li v-if="p.roomType == 2">
                        <span class="content-time">{{ $t('liveRoomManagement.liveRoomList.List.opList.timeDescription') }}{{ p.timeDescription }}</span>
                    </li>
                    <li>
                        <span class="content-time">{{ $t('liveRoomManagement.liveRoomList.List.opList.createRoomTime') }}{{ p.createRoomTime }}</span>
                    </li>
                    <li>
                        <CommonRoomButton :room="p" type="share"></CommonRoomButton>
                        <CommonRoomButton :room="p" :btnUrl="btnUrl" type="edit"></CommonRoomButton>
                        <CommonRoomButton :room="p" type="vodFlag" @loading="$emit('loading', $event)" @update="$emit('update')"></CommonRoomButton>
                        <CommonRoomButton :room="p" type="publish" @loading="$emit('loading', $event)" @update="$emit('update')"></CommonRoomButton>
                    </li>
                    <li>
                        <CommonRoomButton :room="p" type="liveUrl"></CommonRoomButton>
                        <CommonRoomButton :room="p" :selectType="selectType" type="wordLive"></CommonRoomButton>
                        <CommonRoomButton :room="p" :selectType="selectType" type="relatedReport"></CommonRoomButton>
                    </li>
                    <li>
                        <CommonRoomButton :room="p" :selectType="selectType" type="commentManagement"></CommonRoomButton>
                        <CommonRoomButton v-if="!isDAYOO" :room="p" :selectType="selectType" type="realEditor"></CommonRoomButton>
                        <CommonRoomButton :room="p" type="delete" v-if="!nodelete&&(p.userId==userId)" @update="$emit('update')"></CommonRoomButton>
                    </li><!-- (p.userId==userId||selectType!=3)-->
                </ul>
            </div>
        </div>
    </Poptip>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import api from "@/api/Api";
import extend from "extend";
import apimodel from "@/model/ApiModel";
import helper from "@/assets/helper.js";
import PrettyText from "@/components/PrettyText";
import logger from "@/assets/log";
import config from "@/config";
import CommonRoomButton from "@/components/CommonRoomButton";
import ForbiddenSpan from "@/components/ForbiddenSpan";

const log = logger("views:material:all");

let { Const } = apimodel;

export default {
    props: ["p", "btnUrl", "nodelete","selectType"],
    components: {
        PrettyText,
        CommonRoomButton,
        ForbiddenSpan
    },
    mixins: [
        {
            methods: helper
        }
    ],
    data() {
        return {
            Const
        };
    },
    computed: {
        ...mapState({
            userId: state => state.user.id,
            isDAYOO: state => state.config.profile == 'dayoo'
        })
    },
    methods: {
        toDetail(id) {
            if (this.hasPermission("直播间详情功能")) {
                this.$router.push("detail/" + id);
            } else {
                this.$Notice.error({ title: this.$t('Message.permission.error') });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.title-tag {
    border-radius: 5px;
    font-size: 12px;
    background: #A8A8A8;
    padding: 2px;
    color: white;
}
.title-tag-forbidden {
    cursor: pointer;
}
.title-tag-act {
    background-color: rgb(126, 206, 244);
}
.item-thumb {
    height: 90px;
    // 如果设置 line-height: 90px 内容会下移1px，原因不明
    /*line-height: 89px;*/
    width: 160px;
    border-radius: 5px;
    overflow: hidden;
    margin-right: 12px;
    position: relative;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: middle;
        border: 0;
    }
    canvas {
        width: 100%;
        border: 0;
        vertical-align: middle;
    }
    .view {
        width: 160px;
        height: 90px;
        position: absolute;
        top: 0;
        left: 0;
    }
    .view:hover {
        cursor: pointer;
        background: rgba(0, 0, 0, 0.3);
    }
    .view-icon {
        visibility: hidden;
        position: absolute;
        left: 50%;
        top: 50%;
        margin: -12px 0 0 -12px;
        color: #ffffff;
        z-index: 1000;
    }
    .view:hover .view-icon {
        visibility: visible;
    }
    .view:hover .play-btn {
        visibility: visible;
    }
    .play-btn {
        visibility: hidden;
        width: 40px;
        height: 40px;
        font-size: 30px;
        position: absolute;
        cursor: pointer;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: rgba(255, 255, 255, 0.5);
        box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
        border-radius: 40px;
        i {
            width: 100%;
            height: 100%;
            line-height: 40px;
            text-align: center;
            vertical-align: top;
            padding-left: 5px;
        }
    }
    .play-btn:hover {
        background: #fff;
    }
}
.item-info {
    & > .title {
        font-size: 15px;
        color: #666;
        & > * {
            vertical-align: middle;
        }
        a {
            margin-left: 5px;
        }
    }
    .list {
        color: #989898;
        list-style: none;
        margin: 0;
        padding: 0;
        line-height: 19px;

        .title {
            width: 60px;
            display: inline-block;
        }
        .title:after {
            content: ":";
        }
        .video-level-tag {
            border-radius: 2px;
            margin-right: 5px;
            border-bottom: 1px dashed #e3e3e3;
            cursor: pointer;
        }
        .video-level-tag:after {
            content: "、";
        }
        .video-level-tag:last-child:after {
            content: "";
        }
    }
}
.item-op {
    position: absolute;
    right: 0;
    height: auto;
    width: 230px;
    background: white;
    text-align: right;
    white-space: normal;
    .delete_btn2 {
        display: none;
    }
}
</style>